import { Component, Input, Output, EventEmitter, OnDestroy, AfterViewInit, DoCheck, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, filter, map } from 'rxjs/operators';
import { DgMenuService } from './menu.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NbLayoutDirectionService, NbMenuBag, NbToggleStates, NB_WINDOW } from '@nebular/theme';
import { DgMenuItem } from './types';
import { NbMenuBadgeConfig } from '@nebular/theme/components/menu/menu.service';
import { Router } from '@angular/router';
import { SidebarService } from '../services/sidebar.service';
import { DropDownAnimation } from './animation';

@Component({
    selector: '[dgMenuItem]',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    animations: [DropDownAnimation],
    standalone: false
})
export class DgMenuItemComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() menuItem = <DgMenuItem>null;
  @Input() badge: NbMenuBadgeConfig;

  @Output() hoverItem = new EventEmitter<any>();
  @Output() toggleSubMenu = new EventEmitter<any>();
  @Output() selectItem = new EventEmitter<any>();
  @Output() itemClick = new EventEmitter<any>();
  protected destroy$ = new Subject<void>();
  toggleState: NbToggleStates;

  constructor(protected menuService: DgMenuService,
    protected directionService: NbLayoutDirectionService,
    private _router: Router,
    private _sidebarService: SidebarService
  ) { }

  ngOnInit(): void {
    this.setToggleState()
  }

  ngAfterViewInit() {
    this.menuService.onSubmenuToggle()
      .pipe(
        filter(({ item }) => item === this.menuItem),
        map(({ item }: NbMenuBag) => item.expanded),
        takeUntil(this.destroy$),
      )
      .subscribe(isExpanded => this.toggleState = isExpanded ? NbToggleStates.Expanded : NbToggleStates.Collapsed);
  }

  setToggleState() {
    this._sidebarService.getSidebarState("menu-sidebar").subscribe((value) => {
      this.toggleState = value;
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onToggleSubMenu(item: DgMenuItem) {
    // this.toggleSubMenu.emit(item);
    this.menuItem.expanded = !this.menuItem.expanded
  }

  onHoverItem(item: DgMenuItem) {
    this.hoverItem.emit(item);
  }

  onSelectItem(item: DgMenuItem) {
    this.selectItem.emit(item);
  }

  goToPage(isHeaderItem: boolean ,link: string){
    if(isHeaderItem){
      window.location.href = link;
    }
    else{
      this._router.navigateByUrl(link);
    }
  }

  getExpandStateIcon(): string {
    if (this.menuItem.expanded) {
      return 'chevron-down-outline';
    }

    return this.directionService.isLtr()
      ? 'chevron-left-outline'
      : 'chevron-right-outline';
  }
}